import styled from "@emotion/styled";

export const Content = styled.div({
    position: "relative",
});
